import React, { useRef } from 'react';
import styles from './LayoutAnalise.module.scss';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import RelatorioCollapse from '../relatorioCollapse/RelatorioCollapse';
import HeaderProposta from '../headerProposta/HeaderProposta';
import LinkTo from '../../../../core/components/LinkTo';
import Pages from '../../../../config/Pages';
import { useParams } from 'react-router-dom';
import ModalPropostaIndicador from '../../propostaIndicador/components/modalPropostaIndicador/ModalPropostaIndicador';
import analiseNegocialService from '../../../../service/AnaliseNegocialService';
import analiseMetodologicaService from '../../../../service/AnaliseMetodologicaService';
import { download } from '../../../../core/utils/Exporter';
import ConfirmDialog from '../../../../core/components/ConfirmDialog';
import indicadorService from '../../../../service/IndicadorService';

export const layoutAnaliseType = {
    analiseNegocial: 'ANALISE_NEGOCIAL',
    analiseMetodologica: 'ANALISE_METODOLOGICA',
};

function LayoutAnalise({
    children,
    proposta,
    type,
    onVoltar = () => {},
    onSalvar = () => {},
    onFinalizar = () => {},
    disableSalvar = false,
    classNameChildrenContainer = '',
}) {
    const {
        numeroProposta = '',
        nmIndicador = '',
        situacaoProposta = '',
        situacaoAvaliacao = '',
        dataCadastro = '',
        responsavelAnalise = '',
        codgTipoProposta = '',
        file,
    } = proposta ?? {};
    const modalRef = useRef(null);
    const confimRef = useRef(null);
    const { id } = useParams();

    let config = {
        tooltip: 'Relatório de Análise Negocial Atual',
        onClick: () =>
            analiseNegocialService
                .getRelatorio(id)
                .then((response) => download(response, 'Análise Negocial', 'pdf')),
    };
    if (type === layoutAnaliseType.analiseMetodologica) {
        config = {
            tooltip: 'Relatório de Análise Metodológica Atual',
            onClick: () =>
                analiseMetodologicaService
                    .getRelatorio(id)
                    .then((response) => download(response, 'Análise Metodológica', 'pdf')),
        };
    }

    return (
        <>
            <ConfirmDialog ref={confimRef} isOk />
            <ModalPropostaIndicador ref={modalRef} />
            <Card>
                <h5 className={styles.h5}>
                    {type === layoutAnaliseType.analiseMetodologica
                        ? 'Análise Metodológica'
                        : 'Análise Negocial'}
                </h5>
                <div className={`p-col-12 p-grid p-fluid ${styles.container}`}>
                    <div className={`p-col-12 ${styles.firstNav}`}>
                        <HeaderProposta
                            numeroProposta={numeroProposta}
                            nomeIndicador={nmIndicador}
                        />
                        <div className={styles.containerButtons}>
                            <LinkTo
                                to={Pages.sei.statusProposta.url.list.replace(
                                    ':id',
                                    numeroProposta
                                )}
                            >
                                <Button
                                    icon="pi pi-arrow-right-arrow-left"
                                    className="p-button-help"
                                    tooltip="Status da Proposta"
                                    tooltipOptions={{ position: 'top' }}
                                />
                            </LinkTo>
                            <Button
                                icon="pi pi-file"
                                className="p-button-primary p-button-outlined"
                                tooltip="Proposta de indicadores"
                                type="button"
                                disabled={disableSalvar}
                                onClick={() => {
                                    if (codgTipoProposta === 'NOVO_INDICADOR') {
                                        modalRef.current?.show({ id: numeroProposta });
                                    } else if (codgTipoProposta === 'ALTERACAO_INDICADOR') {
                                        indicadorService
                                            .getIndicadorByProposta(numeroProposta)
                                            .then(({ id }) =>
                                                modalRef.current?.show({
                                                    id: numeroProposta,
                                                    idIndicador: id,
                                                })
                                            );
                                    }
                                }}
                                tooltipOptions={{ position: 'top' }}
                            />
                            <Button
                                icon="pi pi-file-pdf"
                                className="p-button-secondary p-button-outlined"
                                tooltip="Relatório de Análise Negocial Atual"
                                type="button"
                                tooltipOptions={{ position: 'top' }}
                                {...config}
                            />
                        </div>
                    </div>
                    <RelatorioCollapse
                        status={situacaoAvaliacao}
                        situacao={situacaoProposta}
                        dataCadastro={dataCadastro}
                        usuarioCadastro={responsavelAnalise}
                        file={file}
                    />
                    <div className={`p-col-12 ${classNameChildrenContainer}`}>{children}</div>
                    <div className="p-col-12">
                        <div className={`buttonsRight ${styles.actionButtons}`}>
                            <Button
                                label="Voltar"
                                icon="pi pi-arrow-left"
                                iconPos="left"
                                className="p-button-secondary"
                                onClick={() => onVoltar()}
                            />
                            {!disableSalvar && (
                                <>
                                    <Button
                                        label="Salvar"
                                        icon="pi pi-check"
                                        iconPos="left"
                                        type="button"
                                        className="p-button-primary"
                                        onClick={() => onSalvar()}
                                    />
                                    <Button
                                        label="Finalizar Análise"
                                        icon="pi pi-sign-in"
                                        iconPos="left"
                                        type="button"
                                        className="p-button-info"
                                        onClick={() => onFinalizar()}
                                    />
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </Card>
        </>
    );
}

export default LayoutAnalise;
